import React, { useEffect, useState  } from 'react';
import { Tabs,Modal } from "@veneer/core";
import Generalconsumables from './generalconsumable';
import Compatibilitypress from './Compatibilitypress';
import Uploadfile from './uploadfile';
import Pricelistcnf from './Pricelistcnf';
function Consumables( {  onShowModal, onCloseDetailsModal, consumabledetail,onsuccessgeneral, origin}) {
    const [selectedTab,setselectedTab]=useState(0)
    const selectTab = (event) => (index) => {
        setselectedTab(index);
    };
    useEffect(()=>{
        setselectedTab(0);
    },[consumabledetail]);
    var  tabs=[];
    if (origin=="one"){ 
        tabs.push( { id: 0, label: 'General', content: <div style={{ padding: '30px' }}><Generalconsumables consumabledetail={consumabledetail} onsuccessgeneral={onsuccessgeneral}/></div> })
    }else{
        tabs.push( { id: 0, label: 'Upload File', content: <div style={{ padding: '30px' }}><Uploadfile/></div> })
    }
    if(consumabledetail===null){}else{
        tabs.push({ id: 1, label: 'Compatibility', content: <div style={{ padding: '30px' }}><Compatibilitypress consumabledetail={consumabledetail}/></div> })
    }


    if (origin=="pricelist"){

        tabs=[];
        tabs.push({ id: 0, label: 'Unconfigured Prices', content: <div style={{ padding: '30px' }}><Pricelistcnf consumabledetail={consumabledetail} onsuccessgeneral={onsuccessgeneral}/></div> })
     }
    ///
    return(
        <Modal
            id="regular-modal"
            onClose={() => { onCloseDetailsModal();  }}
            show={onShowModal}
            css={{
                '.vn-modal--content': {
                    width: "800px !important"
                },
                }}
            title="Consumable configuration"
        >
            <Tabs
                controlId="attached"
                type="attached"
                onChangeTab={selectTab()}
                selectedTabId={selectedTab}
                tabs={
                   tabs
                }
            />
        </Modal>
    );
}
export default Consumables;